<template>
  <div class="container contact">
    <div class="row justify-content-center text-center">
      <div class="col-md-8">
        <h1>Hubungi kami melalui kontak</h1>
        <div class="mt-5">
          <div class="row">
            <div class="col-md-6">
              <div class="card border-0">
                <div class="card-body">
                  <a
                    href="mailto:help@chackra.com"
                    class="btn-icon"
                    target="_blank"
                    ><i
                      class="far fa-envelope fa-3x"
                      style="color: #eb0000"
                    ></i>
                    <div class="title mt-2">pt.chakra@gmail.com</div>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card border-0">
                <div class="card-body">
                  <a href="tel:085892967275" class="btn-icon"
                    ><i
                      class="fas fa-phone-alt fa-3x"
                      style="color: #eb0000"
                    ></i>
                    <div class="title mt-2">0858-9296-7275</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>